<div class="coming-soon" [class.coming-soon--embedded]="embedded">
  @if (backgroundImageSrc) {
    <img
      class="coming-soon__background"
      [src]="backgroundImageSrc"
      alt=""
      aria-hidden="true"
    />
  }

  <div class="coming-soon__scrim" aria-hidden="true"></div>

  <div class="coming-soon__modal" role="status" aria-live="polite">
    <div class="coming-soon__icon-wrap">
      <img
        class="coming-soon__icon"
        [src]="illustrationSrc"
        alt=""
        width="72"
        height="72"
      />
    </div>

    <h1 class="coming-soon__heading">Coming Soon</h1>

    <p class="coming-soon__message">
      {{ featureName }} is currently under development.
    </p>

    @if (description) {
      <p class="coming-soon__description">{{ description }}</p>
    }

    <div class="coming-soon__footer-pill">
      <i class="fa fa-calendar" aria-hidden="true"></i>
      <span>Stay tuned for updates!</span>
    </div>
  </div>
</div>
